import { makeStyles } from '@mui/styles'
const useStyles = makeStyles(() => ({
  boxIconMenu: { cursor: 'pointer' },
  hoverButton: {
    cursor: 'pointer',
    color: '#706E6F',
    '&:hover': {
      color: '#026873'
    }
  },
  hoverButtonRotate: {
    cursor: 'pointer',
    color: '#706E6F',
    transform: 'rotate(180deg)',
    '&:hover': {
      color: '#026873'
    }
  },
  stepperStyle: {
    width: 600,
    '@media all and (max-width: 600px)': {
      width: '100%'
    }
  },
  stepperStyleAddUser: {
    width: 500,
    '@media all and (max-width: 600px)': {
      width: '100%'
    }
  },
  stepperStyleSeeMore: {
    width: 700,
    '@media all and (max-width: 800px)': {
      width: '600px'
    },
    '@media all and (max-width: 600px)': {
      width: '400px'
    },
    '@media all and (max-width: 400px)': {
      width: '100%'
    }
  },
  typographyStyle: {
    fontSize: 15,
    fontWeight: 700,
    textDecoration: 'none',
    textAlign: 'start',
    paddingLeft: '15px',
    '@media all and (max-width: 800px)': {
      fontSize: 14
    },
    '@media all and (max-width: 600px)': {
      fontSize: 13
    },
    '@media all and (max-width: 400px)': {
      fontSize: 13
    }
  },
  boxTypography: {
    width: '100%',
    display: 'flex',
    alignItems: 'center'
    
  },
  boxStyle: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: '0px 15px',
    '@media all and (max-width: 800px)': {
      width: '80%'
    },
    '@media all and (max-width: 600px)': {
      width: '70%'
    },
    '@media all and (max-width: 400px)': {
      width: '80%'
    }
  }
}))

export default useStyles
